function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "file-error",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    id: "secondary-upstroke",
    x1: 18.95,
    y1: 20.5,
    x2: 19.05,
    y2: 20.5,
    style: {
      fill: "none",
      stroke: "var(--icon-color)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "secondary",
    x1: 19,
    y1: 16,
    x2: 19,
    y2: 13,
    style: {
      fill: "none",
      stroke: "var(--icon-color)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M19,9V7L15,3H6A1,1,0,0,0,5,4V20a1,1,0,0,0,1,1h8",
    style: {
      fill: "none",
      stroke: "var(--icon-color)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateError);
export default __webpack_public_path__ + "static/media/state-error.9b01cf0bd644b1f088539e83a10f6f90.svg";
export { ForwardRef as ReactComponent };